import { createFileRoute } from '@tanstack/react-router';

import { AdminArtistsList } from '@/pages/admin/artists/AdminArtistsList';

export const Route = createFileRoute('/admin/_admin/artists')({
  component: AdminArtistsList
});
